<template>
    <!-- everything should be wrapped by one item for some reason -->
    <div>
        <div class="object-titlebox">
            <div class="title-box-left">
                <span v-t="'message.item_peer_to_peer_auto_end_time_setting'"/>
                <el-tooltip effect="dark" placement="top-start">
                    <div slot="content" style="text-align:left" v-html="$t('message.hint_p2p_auto_end_time')"></div>
                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                </el-tooltip>
            </div>
        </div>

        <div class="object-titlebox">
                <div class="object-titlebox-right">
                    <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck()">
                        <img src="../../../../assets/edit.svg"/>
                        <span class="normal-command-text" v-t="'message.common_action_edit'"></span>
                    </button>
                </div>
            </div>
            <table width=100%>
                <tr class="objectitem-record">
                    <td width=40% class="object-item" v-t="'message.item_peer_to_peer_auto_end_time_setting'"></td>
                    <td class="object-value">{{ displayText }}</td>
                </tr>
            </table>
        <p2pAutoEndTimeSettingEdit
            v-if="showP2PAutoEndTimeSettingEdit"
            ref="P2PAutoEndTimeSettingEdit" 
            :appData="appData" 
            @save="setP2PAutoEndTime"
            @cancel="showP2PAutoEndTimeSettingEdit=false" />
    </div>
</template>

<script>
import server from "../../../ServerApi.js";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
import P2PAutoEndTimeSettingEdit from '@/components/pc/setting/p2pSetting/P2PAutoEndTimeSettingEdit.vue';

const LIMIT_SEC_DEFAULT = 3600;
const LIMIT_SEC_MINI = 1;

export default {
    components: {
        p2pAutoEndTimeSettingEdit: P2PAutoEndTimeSettingEdit,
    },
    data() {
        return {
            appData: {},
            showP2PAutoEndTimeSettingEdit: false,
            p2pAutoEndTime: LIMIT_SEC_DEFAULT,
            p2pAutoEndTimeDisplay: "",
        };
    },
    methods: {
        showDialogAfterWritableCheck() {
            if (!this.$root.store.appData.tenantAdminUser) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_need_tenant_admin_privilege"));
                return;
            }
            this.showP2PAutoEndTimeSettingEdit = true;
        },
        async getP2PAutoEndTime() {
            await server.post('/getp2pautoendtime')
            .then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        if (res.data.p2pAutoEndTime < LIMIT_SEC_MINI) {
                            this.appData.p2pAutoEndTime = LIMIT_SEC_DEFAULT;
                            break;
                        }
                        this.appData.p2pAutoEndTime = res.data.p2pAutoEndTime;
                        break;
                    default:
                        this.p2pAutoEndTimeDisplay = "Error";
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "getP2PAutoEndTime").replace("{code}", res.data.status));
                        break;
                }
            })
            .catch((error) => {
                this.p2pAutoEndTimeDisplay = "Error";
                commonUtil.putExceptionErrorMessage(this, "getP2PAutoEndTime", error);
                return;
            });

            if (this.p2pAutoEndTimeDisplay === "Error") {
                return;
            }
            this.createDisplayText();
        },
        async setP2PAutoEndTime(p2pAutoEndTime) {
            this.showP2PAutoEndTimeSettingEdit = false
            let res;
            try {
                res = await server.post('/modifyp2pautoendtime', {p2pAutoEndTime : p2pAutoEndTime})
            } catch(error) {
                commonUtil.putExceptionErrorMessage(this, "setP2PAutoEndTime", error);
                return;
            }

            switch (res.data.status) {
                case constants.STATUS_SUCCESS:
                    commonUtil.notifyMessage(this, 'Success', commonUtil.getMessageText(this.$i18n,"info_p2p_auto_end_time"));
                    this.appData.p2pAutoEndTime = p2pAutoEndTime;
                    break;
                default:
                    commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","setP2PAutoEndTime").replace("{code}",res.data.status));
                    break;
            }

            this.createDisplayText();
        },
        createDisplayText() {
            this.p2pAutoEndTimeDisplay = commonUtil.getMessageText(this.$i18n,"item_peer_to_peer_auto_end_time_option_sec").replace("{time}", Number(this.appData.p2pAutoEndTime));
        }
    },
    mounted: function() {
        this.getP2PAutoEndTime();
    },
    computed: {
        displayText () {
            return this.p2pAutoEndTimeDisplay;
        }
    }
}

</script scoped>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.object-value {
    padding: 10px 10px;
}

.object-title {
    padding: 10px 10px;
    font-size: 12px;
}

.header-value {
    padding-top: 10px;
    padding-bottom: 10px;
    color: #848991;
    font-size: 12px;
}

.title-box-right {
    position: relative;
    text-align: right;
    vertical-align: middle;
    font-size: 12px;
    float: right;
}

.title-box-left {
    padding: 10px;
    padding-left: 20px;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}
.detailed-header {
    width: 95%;
    background-color: #f6f6f6;
    margin-top: 20px;
    margin-bottom: 5px;
    margin-left: 20px;
    margin-right: 20px;
    font-size: 12px;
}
.detailed-table {
    width: 95%;
    margin-left: 20px;
}
.detailed-tr {
    border-bottom:1px #eee solid;
}
.detailed-left {
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 40%;
}
.select-setting {
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
    width:35%;
    height:100%;
    valign:top
}
.vertical-line-addition {
    height: 100vh;
    margin: 0;
    padding: 0;
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
}
.code-guide-text {
     font-size: 16px;
     font-weight: 600;
     color: #5171cb;
 }


</style>
